const getCampaignNameSearchTerm = state => state.platformCampaigns.searchTerm;

export default getCampaignNameSearchTerm;
